import { useEffect } from "react";

export default function Home() {
  useEffect(() => {
    // Redirect to BBL by default
    window.location.href = "/bbl";
  }, []);

  return null;
}
